import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-live-table',
  templateUrl: './live-table.component.html',
  styleUrls: ['./live-table.component.scss']
})
export class LiveTableComponent implements OnInit {
  keyValueArray:any;
  first: any;
second:any;
value1:any;
value2:any;
  constructor(private zone: NgZone,@Inject(MAT_DIALOG_DATA) public injectedData: any) { }

  ngOnInit() {
    this.initWebSocket()
    if(this.injectedData == "K313E25"){
      this.value1 = "Zone 3(Star)";
      this.value2 = "Zone 4(Delta)";
    } else if(this.injectedData == "K312E25"){
      this.value1 = "Zone 1(Delta)";
      this.value2 = "Zone 2(Star)";
    }
  }

  initWebSocket(): void {
    const socket = new WebSocket('wss://api.trafobola.com');
  
    socket.onopen = () => console.log('✅ WebSocket connected');
    socket.onerror = (e) => console.error('❌ WebSocket error:', e);
  
    socket.onmessage = (event) => {
      this.zone.runOutsideAngular(() => {
        try {
          const msg = JSON.parse(event.data);
          if(msg.type == "alertQueue"){
            console.log("asdasda",msg)
          }
          if (msg.topic === 'LV_1' || msg.topic === 'LV_2') {
            const payload = JSON.parse(msg.data);
            if (payload.Deviceid === this.injectedData) {
  
              // Separate logic for first and second payloads
              if (msg.topic === 'LV_1') {
                this.first = payload;
              } else if (msg.topic == 'LV_2') {
                this.second = payload;
              }
  
              // Merge logic after both parts are received
              this.updateKeyValueArray();
            }
          }
        } catch (err) {
          console.error('❌ Error parsing data:', err);
        }
      });
    };
  }
  updateKeyValueArray(): void {
    const keys = Object.keys(this.first || {});
    this.keyValueArray = keys.map((key) => {
      let value2 = '';
      if (this.second && this.second.hasOwnProperty(key)) {
        value2 = this.second[key];
      }
      return {
        key: key,
        value1: this.first[key],
        value2: value2
      };
    });
  }
  
  
}
